<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
    style="width: 100%"
    filterable
    clearable
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userList } from "@/service/getData";

export default {
  props: {
    value: ""
  },
  data() {
    return {
      lists: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await userList({
        size: 500
      });

      if (res.status == 0) {
        this.lists = res.data.list;
      }
    },
    handleChange(e) {
      this.$emit("input", e);
    }
  }
};
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>
